<template lang="pug">
.new-tier
  shForm(title="Nuevo Nivel")
</template>

<script>
import shForm from '@/components/pages/tier/Form'

export default {
  name: 'NewTier',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-tier
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/tier/New.vue